/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Prospero(props) {
  const { nodes, materials } = useGLTF('/models/Black_Arrow.glb')
  return (
    <group {...props} dispose={null}>
        <group position={[0, 0, 0]} scale={1}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Prospero.geometry}
            material={materials.Prospero}
            position={[0, 0, 0]}
            scale={1}
          />
      </group>
    </group>
  )
}
